<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table
      noDataText="Nenhum termo foi encontrado"
      class="tablePrincipal"
      ref="table"
      :data="itens"
    >
      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th></vs-th>
        <vs-th sort-key="Nome">Termo</vs-th>
        <vs-th sort-key="Celular">Preenchido</vs-th>
        <vs-th sort-key="Celular">Data da assinatura</vs-th>
        <!-- <vs-th>Ações</vs-th> -->
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ indextr + 1 }}</vs-td>
            <vs-td>
              <p class="product-category">{{ tr.origem }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ tr.isPreenchido ? "Sim" : "Não" }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-category">
                {{ formataData(tr.dataAssinatura) }}
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!------------ END TABELA ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import service from "../../../services";
import moment from "moment";

export default {
  data() {
    return {
      itens: [],
    };
  },
  methods: {
    buscaDados() {
      this.$vs.loading();

      const objSend = {
        idEvento: this.$route.params.idEvento,
      };

      service
        .post("Eventos", "BuscarTermosEvento", objSend)
        .then((res) => {
          this.itens = [...res.data].map((termo) => ({
            ...termo,
            isPreenchido: termo.termoPreenchido !== null,
          }));
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    formataData(data) {
      return data ? moment(data).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
  mounted() {
    this.buscaDados();
  },
};
</script>
<!------------ END SCRIPT ------------>


<!------------ START STYLE ------------>
<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
<style >
.con-vs-popup .vs-popup {
  width: 1000px !important;
}
</style>
<!------------ END STYLE ------------>
